<script>

    import { createEventDispatcher } from 'svelte'

    import Button from './button.svelte'

    const dispatch = createEventDispatcher()

    export let loading = false
    export let icon = 'trash'
    export let text = 'Borrar'
    export let size = ''

    let isClick = false

    function onClick() {

        if(!isClick) {

            setTimeout(() => {
                isClick = false
            }, 2000)

            return isClick = true
        }

        dispatch('confirm')
    }

</script>

<Button on:click={onClick} type="button" color={isClick ? 'danger' : 'light'} {size} {loading} {icon}>
    {#if isClick}
        <span>Click para confirmar</span>
    {:else}
        <span>{text}</span>
    {/if}
</Button>